export const DEFAULT_THEME_COLOR = '#000'
